'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  children: React.ReactNode;
  dismissOnOverlayClick?: boolean;
}

export default function Modal({ isOpen, onOpenChange, children, dismissOnOverlayClick = true }: ModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.12 }}
          className='fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm'
          onClick={dismissOnOverlayClick ? () => onOpenChange(false) : undefined}>
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.97 }}
            transition={{ duration: 0.12, ease: [0.4, 0, 0.2, 1] }}
            className='relative w-full max-w-md bg-background p-4'
            onClick={(e) => e.stopPropagation()}>
            <span
              onClick={() => onOpenChange(false)}
              className='absolute right-4 top-4 cursor-pointer text-zinc-400 transition-colors hover:text-zinc-900'>
              <X />
            </span>
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
